{
  "clinic_ivf_estimate": {
    "national_ivf_estimate": "Your IVF chances",
    "national_model_scope": "National estimates from CDC, based on people with similar characteristics.",
    "explore_your_ivf_chances": "Explore your IVF chances",
    "national_estimates_explained": "Use your age and reproductive history to explore national estimates. The clinic’s reported outcomes are shown separately below.",
    "enter_your_details": "Enter your details",
    "chance_of_live_birth": "Cumulative chance of a live birth",
    "after_one_retrieval": "After 1 egg retrieval",
    "after_multiple_retrievals": "After ${count} egg retrievals",
    "after_one_additional_retrieval": "After 1 additional egg retrieval",
    "after_multiple_additional_retrievals": "After ${count} additional egg retrievals",
    "after_one_donor_transfer": "After 1 donor-egg embryo transfer",
    "after_multiple_donor_transfers": "After ${count} donor-egg embryo transfers",
    "own_egg_time_horizon": "Each retrieval includes all fresh and frozen embryo transfers within 12 months. Each percentage includes the chances from the preceding retrievals.",
    "donor_time_horizon": "These estimates cover the first 1–3 donor-egg embryo transfers within 12 months of the first transfer. Each percentage includes the chances from the preceding transfers.",
    "bmi_used": "BMI used in the model: ${bmi}. CDC bounds this value between 17 and 45.",
    "national_data_context": "These estimates use U.S. treatment data from 2016–2018. They describe people with similar characteristics and are not a forecast of this clinic’s performance.",
    "details_used_for_estimate": "Details used in this estimate",
    "age_used": "Age: ${age} years",
    "bmi_used_value": "BMI used: ${bmi}",
    "first_ivf_course": "First IVF treatment",
    "previous_ivf_course": "Previous IVF treatment",
    "first_donor_transfer_course": "First donor-egg transfer",
    "pregnancies_used": "Previous pregnancies: ${count}",
    "births_used": "Previous live births: ${count}",
    "edit_estimate_detail": "Edit ${detail}",
    "estimate_without_diagnosis_details": "This estimate uses CDC’s model without diagnosis details.",
    "review_your_details": "Enter the age, measurements and history of the person having IVF. For donor eggs, use the recipient’s details. Answer each question and select all diagnosed reasons, or “I don’t know / no reason”.",
    "age_in_years": "Age in years",
    "height_cm": "Height",
    "weight_kg": "Weight",
    "previous_ivf_use": "Have you used IVF before?",
    "used_ivf_before": "Yes, I have",
    "first_ivf_treatment": "No, this is my first time",
    "egg_source": "Which eggs will you use?",
    "donor_eggs": "Donor eggs",
    "own_eggs": "My own eggs",
    "first_donor_course": "The donor-egg model covers the first 1–3 embryo transfers.",
    "previous_pregnancies": "Previous pregnancies",
    "previous_live_births": "Previous live births",
    "two_or_more": "2 or more",
    "reason_for_ivf": "Reason for IVF",
    "diagnosis": {
      "male_factor": "Male factor",
      "endometriosis": "Endometriosis",
      "tubal": "Tubal factor",
      "pco": "Ovulatory disorder / PCOS",
      "diminished_ovarian_reserve": "Diminished ovarian reserve",
      "uterine": "Uterine factor",
      "other": "Other reason",
      "unexplained": "Unexplained infertility"
    },
    "diagnosis_not_known": "I don’t know / no reason",
    "supported_inputs": "The model supports ages 20–50, heights 122–241 cm and weights 36.3–136 kg. Returning patients using their own eggs must be aged 24–48.",
    "births_cannot_exceed_pregnancies": "Previous live births cannot exceed previous pregnancies.",
    "returning_age_range": "This model supports returning patients aged 24–48.",
    "calculate_your_estimate": "Calculate my estimate",
    "about_cdc_model": "About the CDC model",
    "open_cdc_ivf_estimator": "Open CDC IVF estimator",
    "opens_cdc_website_in_browser": "Opens the CDC website in your browser.",
    "discuss_with_your_clinic": "Talk with your clinic about how these estimates relate to your care. They are for information and cannot guarantee an outcome.",
    "previous_donor_transfers": "Have you had a donor-egg embryo transfer before?",
    "had_donor_transfer_before": "Yes, I have had one",
    "first_donor_transfer": "No, this will be my first",
    "returning_donor_not_supported": "This model covers first-time donor-egg recipients. Ask your clinic about your chances after an earlier donor-egg transfer.",
    "health_notes": "Notes",
    "add_health_note": "Add a note…",
    "sign_in_to_save_health_note": "Sign in to save your note.",
    "save_health_note": "Save note",
    "health_note_saved": "Saved",
    "health_note_save_failed": "Couldn’t save your note. Try again."
  }
}
